module.exports = __webpack_public_path__ + "static/media/icon-menu-logs.9f629157.svg";